import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Icons from "../../../utils/components/icons";
import MultiRangeSlider from "../../../utils/components/common/rangeInput/rangeInput";
import "./DeviceFilter.scss";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../../utils/components/common/modalComponent/ModalComponent";

const DeviceFilter = ({ onFilterChange, cancelFilter, locationHierarchy }) => {
  const { t } = useTranslation("dashboard");
  const filterTab = [
    {
      label: "ClO2 PPB Level",
      key: "clo2",
      icon: Icons.ppbIcon,
      id: "ppb_filter",
    },
    { label: "Mode", key: "mode", icon: Icons.nutIcon, id: "mode_filter" },
    {
      label: "Location",
      key: "deviceLocationHierarchy",
      icon: Icons.locationIconDashboardCard,
      id: "location_filter",
    },
    {
      label: "Cartridge Level",
      key: "cartridgeLevel",
      icon: Icons.newCartridgeIcon,
      id: "cartridge_filter",
    },
    {
      label: "Temperature",
      key: "temperature",
      icon: Icons.barometerIcon,
      id: "temperature_filter",
    },
    {
      label: "Humidity",
      key: "humidity",
      icon: Icons.meterIcon,
      id: "humidity_filter",
    },
  ];
  const rangeMinMaxLimit = {
    clo2: { min: 0, max: 20000 },
    cartridgeLevel: { min: 0, max: 100 },
    temperature: { min: 0, max: 30 },
    humidity: { min: 0, max: 100 },
  };
  const checkboxFilters = ["mode"];
  const checkboxFiltersLabels = {
    mode: [
      {
        label: t("Operational"),
        value: "OPERATIONAL",
        id: "mode_operational",
        icon: Icons.modeOperationalIcon,
      },
      {
        label: t("Research"),
        value: "RESEARCH",
        id: "mode_research",
        icon: Icons.modeResearchIcon,
      },
      {
        label: t("Sense Only"),
        value: "SENSE_ONLY",
        id: "mode_sensonly",
        icon: Icons.modeSenseonlyIcon,
      },
      {
        label: t("Standby"),
        value: "STANDBY",
        id: "mode_standby",
        icon: Icons.modeStandbyIcon,
      },
      {
        label: t("Offline"),
        value: "OFFLINE",
        id: "mode_offline",
        icon: Icons.modeOfflineIcon,
      },
    ],
  };

  const [filterValue, setFilterValue] = useState([
    {
      key: "clo2",
      value: null,
      icon: Icons.ppbIcon,
      unit: "PPB",
      label: "PPB",
    },
    { key: "mode", value: null, icon: Icons.nutIcon, unit: "", label: "Mode" },
    {
      key: "deviceLocationHierarchy",
      value: null,
      icon: Icons.locationIconDashboardCard,
      unit: "",
      label: "Location",
      customValue: [],
    },
    {
      key: "cartridgeLevel",
      value: null,
      icon: Icons.newCartridgeIcon,
      unit: "%",
      label: "Cartridge",
    },
    {
      key: "temperature",
      value: null,
      icon: Icons.barometerIcon,
      unit: "C",
      label: "Temp",
    },
    {
      key: "humidity",
      value: null,
      icon: Icons.meterIcon,
      unit: "%",
      label: "Humidity",
    },
  ]);
  const [activeTab, setActiveTab] = useState("");
  // const [locationLevelIndex, setLocationLevelIndex] = useState("");
  // const [locationLevelLink, setLocationLevelLink] = useState([]);
  const [viewLevelIndex, setViewLevelIndex] = useState("");
  const [cancelModal, setCancelModal] = useState(false);

  const handleRangeChange = ({ min, max, key }) => {
    const filters = [...filterValue];
    const singleFilterIndex = [...filterValue].findIndex(
      (item) => item.key === key
    );
    filters[singleFilterIndex].value = { between: [min, max] };
    setFilterValue(filters);
  };
  const getActiveLabel = () => {
    return filterTab.find((item) => item.key === activeTab);
  };
  const getFilterValue = (key) => {
    const singleFilter = [...filterValue].find((item) => item.key === key);
    if (singleFilter !== undefined && singleFilter.value !== null) {
      return singleFilter.value?.between || null;
    }
    return null;
  };
  const getFilterUnit = (key) => {
    return filterValue.find((item) => item.key === key).unit;
  };
  const handleTabClick = (key) => {
    setActiveTab(key);
  };
  const handleCheckBoxChange = (e) => {
    const inputVal = e.target.defaultValue;
    const inputName = e.target.name.split("_")[0];
    const filters = [...filterValue];
    const singleFilterIndex = [...filterValue].findIndex(
      (item) => item.key === inputName
    );
    const list =
      filters[singleFilterIndex].value !== null
        ? filters[singleFilterIndex].value.split(",")
        : [];
    if (list.includes(inputVal)) {
      const index = list.findIndex((item) => item === inputVal);
      list.splice(index, 1);
    } else {
      list.push(inputVal);
    }
    filters[singleFilterIndex].value = list.length > 0 ? list.join(",") : null;

    setFilterValue(filters);
  };
  const isCheckboxChecked = (value) => {
    const getSelectedTab = [...filterValue].find(
      (item) => item.key === activeTab
    );
    // const list = getSelectedTab.value.split(',');
    if (getSelectedTab.value !== null && getSelectedTab.value.includes(value)) {
      return true;
    }
    return false;
  };
  const isBtnChecked = (value) => {
    const getSelectedTab = [...filterValue].find(
      (item) => item.key === activeTab
    );
    if (getSelectedTab.value === value) {
      return true;
    }
    return false;
  };

  const applyFilter = () => {
    const changedFilters = [];
    filterValue.forEach((elem) => {
      if (elem.value !== null) {
        if (rangeMinMaxLimit[elem.key] !== undefined) {
          if (
            rangeMinMaxLimit[elem.key].min === elem.value.between[0] &&
            rangeMinMaxLimit[elem.key].max === elem.value.between[1]
          ) {
            changedFilters.push({ ...elem, value: null });
          } else {
            changedFilters.push(elem);
          }
        } else {
          changedFilters.push(elem);
        }
      } else {
        changedFilters.push(elem);
      }
    });
    onFilterChange(changedFilters);
    cancelFilter();
  };

  const discardFilter = () => {
    cancelFilter();
  };

  /**
  const selectLocation = (index) => {
    let indexArr = [];
    console.log('selectLocation => ', index);
    let hierarchy = [...locationHierarchy];
    if (index.length > 0) {
      indexArr = index.split("_");
      let levelNames = [];
      indexArr.forEach((elem, ind) => {
        if (ind === 0) {
          hierarchy = [...locationHierarchy];
          let arr = indexArr.slice(0, ind + 1);
          levelNames.push({
            name: hierarchy[elem].LocationName,
            indexs: arr.join("_"),
          });
        } else if (ind === 2) {
          hierarchy = [...locationHierarchy][indexArr[ind - 1]].Level2;
          let arr = indexArr.slice(0, ind - 1);
          levelNames.push({
            name: hierarchy[elem].LocationName,
            indexs: ["0", ...arr].join("_"),
          });
        } else if (ind === 3) {
          hierarchy = [...locationHierarchy][indexArr[ind - 2]].Level2[
            indexArr[ind - 1]
          ].Level3;
          let arr = indexArr.slice(0, ind - 1);
          levelNames.push({
            name: hierarchy[elem].LocationName,
            indexs: ["0", ...arr].join("_"),
          });
        }
      });

      const filters = [...filterValue];
      const singleFilterIndex = [...filterValue].findIndex(
        (item) => item.key === "deviceLocationHierarchy"
      );
      filters[singleFilterIndex].value =
        hierarchy[indexArr[indexArr.length - 1]].SK;
      filters[singleFilterIndex].customValue = levelNames;
      setFilterValue(filters);
    }
  };

  const viewFloorLevel = (index) => {
    console.log('viewFloorLevel => ', index);
    const indexArr = index.split("_");
    if (indexArr.length <= 3) {
      let hierarchy = [...locationHierarchy];
      let levelNames = [];
      indexArr.forEach((elem, ind) => {
        if (ind === 0) {
          hierarchy = [...locationHierarchy];
          let arr = indexArr.slice(0, ind + 1);
          levelNames.push({
            name: hierarchy[elem].LocationName,
            indexs: arr.join("_"),
          });
        } else if (ind === 1) {
          hierarchy = [...locationHierarchy][indexArr[ind - 1]].Level2;
          let arr = indexArr.slice(0, ind + 1);
          levelNames.push({
            name: hierarchy[elem].LocationName,
            indexs: arr.join("_"),
          });
        } else if (ind === 3) {
          hierarchy = [...locationHierarchy][indexArr[ind - 2]].Level2[
            indexArr[ind - 1]
          ].Level3;
        }
      });

      const filters = [...filterValue];
      const singleFilterIndex = [...filterValue].findIndex(
        (item) => item.key === "deviceLocationHierarchy"
      );
      filters[singleFilterIndex].value = null;
      filters[singleFilterIndex].customValue = [];
      setFilterValue(filters);

      setLocationLevelLink(levelNames);
      setLocationLevelIndex(index);
    }
  };

  const renderLocationHierarchy = (index = "") => {
    let indexArr = [];
    if (index.length > 0) {
      indexArr = index.split("_");
    }
    let hierarchy = [...locationHierarchy];
    let nameKey = "LocationName";
    indexArr.forEach((elem, ind) => {
      if (ind === 0) {
        hierarchy = [...locationHierarchy][elem].Level2;
      } else if (ind === 1) {
        hierarchy = [...locationHierarchy][indexArr[ind - 1]].Level2[elem].Level3;
      }
      // else if (ind === 2) {
      //   hierarchy = [...locationHierarchy][indexArr[ind - 2]].Level2[
      //     indexArr[ind - 1]
      //   ].Level3;
      // }
    });

    console.log('hierarchy => ', index);
    console.log('hierarchy => ', hierarchy);

    return hierarchy.map((item, ind) => (
      <label
        className={classNames("customRadio", {
          active: isBtnChecked(item?.SK),
        })}
        key={`${item.PK}_${ind}`}
        onClick={() => {
          const i = index.length > 0 ? index + "_" : "";
          selectLocation(i + "" + ind);
        }}
        onDoubleClick={() => {
          const i = index.length > 0 ? index + "_" : "";
          viewFloorLevel(i + "" + ind);
        }}
      >
        {nameKey === "RoomName" ? Icons.roomIcon : Icons.buildingIcon}
        <span>{item[nameKey]}</span>
      </label>
    ));
  };

  const getDeviceLocation = () => {
    const itm = filterValue.find(
      (item) => item.key === "deviceLocationHierarchy"
    );
    console.log('getDeviceLocation => ', itm);
    return itm.customValue.length > 0
      ? itm.customValue[itm.customValue.length - 1].indexs
      : locationLevelIndex;
  };

  */

  // const viewFloorLevel = (index) => {
  //   setViewLevelIndex(index);
  // };

  const selectLocation = (index, isDoubleClick = false) => {
    const indexArr = index.split("_");
    let hierarchy = [...locationHierarchy];
    let levelNames = [];
    let skValue = "";
    indexArr.forEach((elem, ind) => {
      if (ind === 0) {
        levelNames.push({
          name: hierarchy[elem].LocationName,
          indexs: indexArr.slice(0, ind + 1).join("_"),
        });
        skValue = hierarchy[elem].SK;
      } else if (ind === 1) {
        levelNames.push({
          name: hierarchy[indexArr[0]].Level2[elem].LocationName,
          indexs: indexArr.slice(0, ind + 1).join("_"),
        });
        skValue = hierarchy[indexArr[0]].Level2[elem].SK;
      } else if (ind === 2) {
        levelNames.push({
          name: hierarchy[indexArr[0]].Level2[indexArr[1]].Level3[elem]
            .LocationName,
          indexs: indexArr.slice(0, ind + 1).join("_"),
        });
        skValue = hierarchy[indexArr[0]].Level2[indexArr[1]].Level3[elem].SK;
      }
    });
    const filters = [...filterValue];
    const singleFilterIndex = [...filterValue].findIndex(
      (item) => item.key === "deviceLocationHierarchy"
    );
    filters[singleFilterIndex].value = skValue;
    filters[singleFilterIndex].customValue = levelNames;
    setFilterValue(filters);

    if (isDoubleClick) {
      setViewLevelIndex(index);
    }
  };

  const checkNextLevel = (index) => {
    let indexArr = index.split("_");
    let list = [...locationHierarchy];
    indexArr.forEach((elem, ind) => {
      if (ind === 0) {
        list = [...locationHierarchy][elem]?.Level2 || [];
      } else if (ind === 1) {
        list = [...locationHierarchy][indexArr[0]].Level2[indexArr[1]].Level3;
      }
    });
    return list.length > 0;
  };

  const renderLocationHierarchy = () => {
    let indexArr = [];
    let hierarchy = [...locationHierarchy];

    if (viewLevelIndex !== "") {
      indexArr = viewLevelIndex.split("_");
      indexArr.forEach((elem, ind) => {
        if (ind === 0) {
          hierarchy = [...locationHierarchy][elem]?.Level2 || [];
        } else if (ind === 1) {
          hierarchy = [...locationHierarchy][indexArr[0]].Level2[indexArr[1]]
            .Level3;
        }
      });
    }

    return hierarchy.map((item, ind) => (
      <label
        className={classNames("customRadio", {
          active: isBtnChecked(item?.SK),
        })}
        key={`${item.PK}_${ind}`}
        onClick={() => {
          const i = viewLevelIndex.length > 0 ? viewLevelIndex + "_" : "";
          selectLocation(i + "" + ind, false);
        }}
        onDoubleClick={() => {
          const i = viewLevelIndex.length > 0 ? viewLevelIndex + "_" : "";
          const check = checkNextLevel(i + "" + ind);
          if ((viewLevelIndex === "" || indexArr.length < 2) && check) {
            selectLocation(i + "" + ind, true);
          }
        }}
      >
        {Icons.buildingIcon}
        <span>{item.LocationName}</span>
      </label>
    ));
  };

  const resetLocationLink = (ind) => {
    const filters = [...filterValue];
    const singleFilterIndex = [...filterValue].findIndex(
      (item) => item.key === "deviceLocationHierarchy"
    );

    // Update customValue to include only up to the clicked level
    filters[singleFilterIndex].customValue = filters[
      singleFilterIndex
    ].customValue.slice(0, ind + 1);

    // Set the value to the SK of the clicked level
    filters[singleFilterIndex].value =
      filters[singleFilterIndex].customValue[ind].SK;

    // Update the filter
    setFilterValue(filters);

    // Set the viewLevelIndex to the indexs of the level before the clicked one
    // This ensures we show the correct level's children
    if (ind === 0) {
      setViewLevelIndex(""); // For level 1, show the top level
    } else {
      setViewLevelIndex(filters[singleFilterIndex].customValue[ind - 1].indexs);
    }
  };

  const renderLocationLinks = () => {
    const filters = [...filterValue];
    const singleFilterIndex = filters.findIndex(
      (item) => item.key === "deviceLocationHierarchy"
    );

    return filters[singleFilterIndex].customValue.map((item, ind) => (
      <React.Fragment key={`location_level_link_${ind}`}>
        <button
          type="button"
          className="locationLevelLink active"
          onClick={() => resetLocationLink(ind)}
          id={`location_level_link_${ind}`}
        >
          {item.name}
        </button>
        {ind < filters[singleFilterIndex].customValue.length - 1 && (
          <span className="ms-2 me-2 d-block" id="separator">
            /
          </span>
        )}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    if (activeTab === "") {
      setActiveTab("clo2");
      const getFilter = localStorage.getItem("filters");
      if (getFilter !== null) {
        setFilterValue(JSON.parse(getFilter));
      }
    }
  }, [activeTab]);

  return (
    <>
      <div className="filterSideBar">
        <ul id="filterlist">
          {filterTab.map((item, index) => (
            <li
              className={classNames(`${item.key}`, {
                active: activeTab === item.key,
              })}
              id={item.id}
              key={`filter_tab_${index}`}
              onClick={() => handleTabClick(item.key)}
            >
              {item.icon}
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="filterBody justify-content-between d-flex flex-column flex-fill">
        <div className="d-flex flex-column flex-fill filter-content">
          <p id="filters_text">Filters</p>
          {activeTab && (
            <>
              <div className="fluid d-flex align-items-center filerLabel">
                {getActiveLabel().icon}
                <span id="active_filter_label">{getActiveLabel().label}</span>
                {activeTab === "deviceLocationHierarchy" && (
                  <div
                    className="d-flex align-items-center ms-4 locationLevelLinkWrapper"
                    id="locationLevelLinkWrapper"
                  >
                    {/* {locationLevelLink.map((item, index) => (
                      <>
                        <button
                          type="button"
                          className="locationLevelLink active"
                          onClick={() => viewFloorLevel(item.indexs)}
                          key={`location_level_link_${index}`}
                          id={`location_level_link_${index}`}
                          // disabled={index === locationLevelLink.length - 1}
                        >
                          {item.name}
                        </button>
                        {index < locationLevelLink.length - 1 && (
                          <span className="ms-2 me-2 d-block"> / </span>
                        )}
                      </>
                    ))} */}
                    {renderLocationLinks()}
                  </div>
                )}
              </div>

              {activeTab === "clo2" && (
                <div className="d-flex flex-column">
                  <MultiRangeSlider
                    min={rangeMinMaxLimit[activeTab].min}
                    max={rangeMinMaxLimit[activeTab].max}
                    value={getFilterValue(activeTab)}
                    id={activeTab}
                    onChange={handleRangeChange}
                    unit={getFilterUnit(activeTab)}
                  />
                </div>
              )}
              {activeTab === "cartridgeLevel" && (
                <div className="d-flex flex-column">
                  <MultiRangeSlider
                    min={rangeMinMaxLimit[activeTab].min}
                    max={rangeMinMaxLimit[activeTab].max}
                    value={getFilterValue(activeTab)}
                    id={activeTab}
                    onChange={handleRangeChange}
                    unit={getFilterUnit(activeTab)}
                  />
                </div>
              )}
              {activeTab === "temperature" && (
                <div className="d-flex flex-column">
                  <MultiRangeSlider
                    min={rangeMinMaxLimit[activeTab].min}
                    max={rangeMinMaxLimit[activeTab].max}
                    value={getFilterValue(activeTab)}
                    id={activeTab}
                    onChange={handleRangeChange}
                    unit={getFilterUnit(activeTab)}
                  />
                </div>
              )}
              {activeTab === "humidity" && (
                <div className="d-flex flex-column">
                  <MultiRangeSlider
                    min={rangeMinMaxLimit[activeTab].min}
                    max={rangeMinMaxLimit[activeTab].max}
                    value={getFilterValue(activeTab)}
                    id={activeTab}
                    onChange={handleRangeChange}
                    unit={getFilterUnit(activeTab)}
                  />
                </div>
              )}

              {checkboxFilters.includes(activeTab) && (
                <div className="d-flex flex-wrap mode-filters">
                  {checkboxFiltersLabels[activeTab].map((item, index) => (
                    <label
                      htmlFor={item.id}
                      id={`${item.id}_label`}
                      className={classNames("customRadio", {
                        active: isCheckboxChecked(item.value),
                      })}
                      key={`${item.id}_${index}`}
                      // onClick={() => handleCheckBoxChange(item.value, activeTab)}
                    >
                      <input
                        type="checkbox"
                        name={`${activeTab}_${item.id}`}
                        value={item.value}
                        id={item.id}
                        onChange={handleCheckBoxChange}
                        checked={isCheckboxChecked(item.value)}
                      />
                      {item.icon}
                      <span>{item.label}</span>
                    </label>
                  ))}
                </div>
              )}

              {activeTab === "deviceLocationHierarchy" && (
                <>
                  <div className="d-flex flex-wrap filter-location-content">
                    {renderLocationHierarchy()}
                  </div>
                </>
              )}
            </>
          )}
        </div>

        <div className="d-flex justify-content-end align-items-center filterFooter">
          <button
            type="button"
            id="cancel_filter"
            onClick={() => setCancelModal(true)}
            className="roundBtn dark"
          >
            <span>Cancel</span>
          </button>
          <button
            type="button"
            id="apply_filter"
            onClick={() => applyFilter()}
            className="roundBtn primary"
            // disabled={isDisabled}
          >
            <span>Apply</span>
          </button>
        </div>

        <ModalComponent
          idName="cancelmodal"
          isOpen={cancelModal}
          onCloseModal={() => setCancelModal(false)}
          descriptionText={t("cancel_filter_modal")}
          needConfirmation={true}
          onConfirm={() => discardFilter()}
          onClose={() => setCancelModal(false)}
        ></ModalComponent>
      </div>
    </>
  );
};

export default DeviceFilter;
